import Game from "../../../../src/Game";
import PointManager from "./PointManager";
import LineManager from "./LineManager";
import AngleManager from "./AngleManager";
import AngleBgManager from "./AngleBgManager";
import PointTagManager from "./PointTagManager";
import Circle from "../../../../src/entities/Circle";
import SliderManager from "./SliderManager";
import IntroAnimationManager from "./IntroAnimationManager/IntroAnimationManager";

import InfoSlider from "../../../../src/entities/InfoSlider/InfoSlider";
import CalculationLine from "../entities/CalculationLine";
import GuideText from "../../../../src/entities/GuideText";

import { CIRCLE_RADIUS, CENTER_OF_CIRCLE, INFO_SLIDER_COORD, INFO_SLIDER_ASSETS, CALC_LINE_COORD, ARC_COLOR_ARR } from "../types/Config";
import isCircumPointBetween from "../../../../src/utils/isCircumPointBetween";

import { EventBus, EnumEventBus } from "./EventBus";
import { RootEventBus, EnumRootEventBus } from "../../../../src/managers/RootEventBus";
import generatePoints from "../../../../src/utils/generatePoints";
import { getCircleRadians } from "../helpers/getCircleRadians";


export default class ComponentManager {
  static instance;
  Game = Game.getInstance();
  RootEventBus = RootEventBus;
  EventBus = EventBus;
  cRadius = CIRCLE_RADIUS;
  calcLineCoord = CALC_LINE_COORD;
  cCoord = this.isPortail();

  PointManager = new PointManager(this.cCoord);
  AngleBgManager = new AngleBgManager(this.cCoord, this.PointManager.getRadians()[0]);
  LineManager = new LineManager();
  AngleManager = new AngleManager();
  PointTagManager = new PointTagManager();
  SliderManager = new SliderManager();
  infoSlider = new InfoSlider(INFO_SLIDER_COORD, INFO_SLIDER_ASSETS);
  calcLine = new CalculationLine(this.calcLineCoord);
  IntroAnimationManager: IntroAnimationManager;
  circle: Circle;

  constructor() {
    if (!ComponentManager.instance) {
      ComponentManager.instance = this;
    }
    this.isPortail();
    const radians = this.PointManager.getRadians();
    this.circle = new Circle(this.cCoord, radians, ARC_COLOR_ARR);
    this.setPointTagManagerVis(false);
    this.IntroAnimationManager = new IntroAnimationManager(this.PointManager, this.AngleManager, this.AngleBgManager, this.LineManager, this.SliderManager, this.circle, this.calcLine);

    new GuideText({ x: 100, y: 10 });
    this.runIntroAnimation();

    this.RootEventBus.on(EnumRootEventBus.completedIntroAnim, () => {
      this.setPointTagManagerVis(true)
      this.drawElements();
    });
    this.EventBus.on(EnumEventBus.drawElements, () => this.drawElements());
    this.RootEventBus.on(EnumRootEventBus.drawElements, () => this.drawElements());

  }
  static getInstance = () => ComponentManager.instance;
  setPointTagManagerVis = (vis: boolean) => this.PointTagManager.setVisible(vis);
  runIntroAnimation = () => this.IntroAnimationManager.runAnimations();
  generatePointTagPoints = () => generatePoints(this.cCoord, this.PointManager.getRadians(), this.cRadius + 34);

  isPortail() {
    const dim = this.Game.getDim();
    if (dim.WIDTH > dim.HEIGHT) {
      return CENTER_OF_CIRCLE
    }
    this.calcLineCoord = {
      x: dim.WIDTH / 2 - 200,
      y: dim.HEIGHT / 2 + 250
    }
    return {
      x: dim.WIDTH / 2,
      y: dim.HEIGHT / 2
    }
  }


  drawElements() {
    const points = this.PointManager.getRedPoints();
    const radians = this.PointManager.getRadians();
    const isbtw = isCircumPointBetween(this.cCoord, points[2], radians[0], radians[1]);

    this.PointManager.draw();
    this.circle.draw({ radians: getCircleRadians(radians, isbtw), radius: this.cRadius });
    this.LineManager.draw(this.PointManager.getPoints());
    this.AngleManager.draw(this.PointManager.getPoints(), isbtw);
    this.PointTagManager.updateCenterName(this.PointManager.getPoints(), isbtw);
    this.PointTagManager.updateCoord(this.generatePointTagPoints())
  }
}

